import { connect } from 'react-redux';
import { setShoppingListView } from 'Favourites/store/actions';

import {
    selectShoppingListView,
} from 'store/reducers/data/shoppingList';

import { selectProducts } from 'Favourites/store/reducers/data/products';
import appStorage from 'helpers/AppStorage';

const getViewForShoppingList = (state) => {
    return selectShoppingListView(state) || appStorage('shoppingListView') || (window.Checkout.settings.allow_add_to_bag ? 'buyonline' : 'availableinstore');
};

const mapStateToProps = (state) => {
    const shoppingListView = getViewForShoppingList(state);
    const availableProducts = Object.keys(selectProducts(state)).length > 0;

    return { shoppingListView, availableProducts };
};

const mapDispatchToProps = (dispatch) => {
    return {
        triggerShoppingListViewChange: (value) => {
            dispatch(setShoppingListView(value));
            appStorage('shoppingListView', value);
        },
        setShoppingListView: (value) => {
            dispatch(setShoppingListView(value));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps);
